module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-09.7392da0c.png";